import { render, staticRenderFns } from "./EventRegistrationTickets.vue?vue&type=template&id=1d2ce9c1&"
import script from "./EventRegistrationTicketsVue.ts?vue&type=script&lang=ts&"
export * from "./EventRegistrationTicketsVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports